import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SEND_TEST_EMAIL_MUTATION = gql`
  mutation sendTestEmail($recipient: String!, $subject: String!, $htmlContent: String!, $preheader: String, $textContent: String, $sampleDataJson: String, $templateId: String) {
    sendTestEmail(recipient: $recipient, subject: $subject, htmlContent: $htmlContent, preheader: $preheader, textContent: $textContent, sampleDataJson: $sampleDataJson, templateId: $templateId) {
      isAuth
      success
      error
    }
  }
`;

const sendTestEmail = async ({
  recipient, subject, htmlContent, preheader, textContent, sampleDataJson, templateId,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: SEND_TEST_EMAIL_MUTATION,
        variables: {
          recipient, subject, htmlContent, preheader, textContent, sampleDataJson, templateId,
        },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { sendTestEmail: sendTestEmailData } } = result;

    if (sendTestEmailData) return sendTestEmailData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: sendTestEmailData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: sendTestEmail Error: ${error}`);
    return null;
  }
};

export default sendTestEmail;
